import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import axios from "axios";
import InventoryDocumentInvoices from '../../inventory/inventorydocument/InventoryDocumentInvoices';

const PurchaseorderInventorydocumentListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [inventorydocuments, setInventorydocuments] = useState([]);
  const [status, setStatus] = useState('');
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(false);
  const poStatus = String(status || '').toUpperCase();
  const canEditPo = ['NEW', 'IN_PROGRESS'].includes(poStatus);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-eye" className="  p-button-default p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (entity === 'transfer-supplier') {
                      history.push('/inventory/' + props.entity + '/read/' + rowData.id)
                    }
                    if (entity === 'purchase-order') {
                      history.push('/procurement/purchase-order/' + action + '/' + id + '?read=inventorydocument&inventoryDocumentId=' + rowData.id + '&type=transfer-supplier')
                    }
                  }}/>
        }
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button
            icon="pi pi-copy"
            className="p-button-info p-mr-2"
            tooltip="Kapcsolódó számlák"
            tooltipOptions={{ position: 'left' }}
            disabled={rowData.status !== 'COMPLETED'}
             onClick={() => {
              history.push(
                '/procurement/purchase-order/read/' +
                id +
                '?copy=inventorydocument-receipt&inventoryDocumentId=' +
                rowData.id
              );
            }}
          />
        }
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  disabled={rowData.status !== 'DRAFT' || !canEditPo}
                  onClick={() => {
                    if (entity === 'transfer-supplier') {
                      history.push('/inventory/' + props.entity + '/update/' + rowData.id)
                    }
                    if (entity === 'purchase-order') {
                      history.push('/procurement/purchase-order/' + action + '/' + id + '?update=inventorydocument&inventoryDocumentId=' + rowData.id + '&type=transfer-supplier')
                    }
                  }}/>
        }
        {/*{localStorage.getItem('roles').toString().includes('role_') &&*/}
        {/*  <Button icon="pi pi-trash" className="p-button-danger"*/}
        {/*          tooltip={t('delete')} tooltipOptions={{position: 'left'}}*/}
        {/*          onClick={() => {*/}
        {/*            if (window.confirm('A törlés megerősítésére van szükség!')) {*/}
        {/*              setLoading(true);*/}
        {/*              apiCall('delete', '/api/v2/inventory-document/' + rowData.id)*/}
        {/*                .then(response => {*/}
        {/*                  window.App.toastShow('success', 'Sikeres törlés!');*/}
        {/*                  window.App.setState({rerenderPurchaseorderInventorydocumentList: Math.random()})*/}
        {/*                })*/}
        {/*                .catch(error => {*/}
        {/*                  window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
        {/*                })*/}
        {/*                .finally(() => {*/}
        {/*                  setLoading(false);*/}
        {/*                })*/}
        {/*            }*/}
        {/*          }}*/}
        {/*  />*/}
        {/*}*/}
      </React.Fragment>
    );
  }

  useEffect(() => {
    apiCall('GET', '/api/v2/dictionary/inventory-document-status')
      .then(response => {
        setStatuses(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if(id) {
      setLoading(true)
      apiCall('get', '/api/v2/purchase-order/' + id)
        .then(response => {
          setStatus(response.data.data.status)
          setInventorydocuments(response.data.data.inventory_documents)
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [window.App.state.rerenderPurchaseorderInventorydocumentList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={inventorydocuments}
                 loading={loading} lazy
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 dataKey="id"
      >
        <Column field="document_number" header={t('columnDeliveryNoteNumber')} sortable filter></Column>
        {(localStorage.getItem('roles') || '').includes('role_receipt_read') &&
          <Column header={t('deliveryLinkedInvoices')} body={row => <InventoryDocumentInvoices document={row}/>}/>}
        <Column field="status" header={t('columnStatus2')} sortable filter body={(rowData) => {
          let status = statuses.find(status => status.key === rowData.status)
          return(
            <>{status?.value}</>
          )
        }}></Column>
        {/*<Column field="type" header={t('columnType')} sortable filter></Column>*/}
        <Column field="date" header={t('columnDate')} sortable filter></Column>


        <Column field="created_at" header={t('columnCreatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.created_at)}</>
          )
        }}></Column>
        <Column field="updated_at" header={t('columnUpdatedAt')} sortable body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.updated_at)}</>
          )
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(PurchaseorderInventorydocumentListComponent);
